import React from 'react';


class AlignPicker extends React.Component {
    constructor(props) {
        super(props);

        
        this.defaultState = this.defaultState.bind(this);
        this.onChange = this.onChange.bind(this);
        
        this.defaultState(props);

        
    }

    defaultState(props) {
        this.state = {
            'align':'center'     
        };

        if(props.align) {
            this.state.align = props.align;
        }        
    }



    componentWillReceiveProps(nextProps) {
        this.defaultState(nextProps);
    }



    onChange(e,align) {
        this.setState({align:align});
        this.props.handleChange(this.props.id,align);
    }

    render() {
       
        return (
            <div className="col-sm-12 p-0">
               <div className="btn-group col-sm-12 p-0" aria-label="Default button group" role="group">
                   <a href="javascript:void(0)" onClick={(e) => this.onChange(e,'left')} className={`col-sm-4 ${(this.state.align == 'left' ? 'current':'')} btn btn-outline btn-default`}>Left</a>
                   <a href="javascript:void(0)" onClick={(e) => this.onChange(e,'center')} className={`col-sm-4 ${(this.state.align == 'center' ? 'current':'')} btn btn-outline btn-default`}>Center</a>
                   <a href="javascript:void(0)" onClick={(e) => this.onChange(e,'right')} className={`col-sm-4 ${(this.state.align == 'right' ? 'current':'')} btn btn-outline btn-default`}>Right</a>
               </div>
            </div>
        );
    }

  
}

export default AlignPicker;




// WEBPACK FOOTER //
// ./components/builder/AlignPicker.js